export default __webpack_public_path__ + "static/media/underground.7d279886.png";